import { render, staticRenderFns } from "./BMW2025ChargingDisclosurei4i5iX.vue?vue&type=template&id=0a65df58&"
import script from "./BMW2025ChargingDisclosurei4i5iX.vue?vue&type=script&lang=js&"
export * from "./BMW2025ChargingDisclosurei4i5iX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports